import React, { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import { IconProps } from './icon.types';

export type LiquidityIconProps = IconProps;

const LiquidityIcon: FC<LiquidityIconProps> = ({ className, ...props }) => (
  <svg
    className={twMerge('shrink-0', className)}
    fill="none"
    height="16"
    viewBox="0 0 16 16"
    width="16"
    {...props}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_14577_90046)">
      <g filter="url(#filter0_i_14577_90046)">
        <path
          d="M10.667 5.33301H10.6603M14.667 3.46634L14.667 6.44935C14.667 6.77547 14.667 6.93853 14.6302 7.09198C14.5975 7.22803 14.5436 7.35809 14.4705 7.47739C14.3881 7.61194 14.2728 7.72724 14.0422 7.95785L8.92973 13.0703C8.1377 13.8623 7.74168 14.2583 7.28503 14.4067C6.88334 14.5372 6.45065 14.5372 6.04896 14.4067C5.5923 14.2583 5.19628 13.8623 4.40425 13.0703L2.92974 11.5957C2.1377 10.8037 1.74169 10.4077 1.59331 9.95104C1.46279 9.54935 1.46279 9.11666 1.59331 8.71497C1.74169 8.25832 2.1377 7.8623 2.92974 7.07026L8.04215 1.95785C8.27276 1.72724 8.38806 1.61194 8.52261 1.52949C8.64191 1.45638 8.77197 1.40251 8.90802 1.36985C9.06147 1.33301 9.22453 1.33301 9.55065 1.33301L12.5337 1.33301C13.2804 1.33301 13.6538 1.33301 13.939 1.47833C14.1899 1.60616 14.3938 1.81014 14.5217 2.06102C14.667 2.34624 14.667 2.7196 14.667 3.46634ZM10.3337 5.33301C10.3337 5.5171 10.4829 5.66634 10.667 5.66634C10.8511 5.66634 11.0003 5.5171 11.0003 5.33301C11.0003 5.14891 10.8511 4.99967 10.667 4.99967C10.4829 4.99967 10.3337 5.14891 10.3337 5.33301Z"
          stroke="url(#paint0_linear_14577_90046)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.33333"
        />
      </g>
    </g>
    <defs>
      <filter
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
        height="15.702"
        id="filter0_i_14577_90046"
        width="14.502"
        x="0.830078"
        y="0.667969"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" mode="normal" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="1.2" />
        <feGaussianBlur stdDeviation="0.6" />
        <feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0" />
        <feBlend in2="shape" mode="normal" result="effect1_innerShadow_14577_90046" />
      </filter>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint0_linear_14577_90046"
        x1="14.9414"
        x2="1.76983"
        y1="4.90031"
        y2="18.2091"
      >
        <stop stopColor="#F79009" />
        <stop offset="1" stopColor="#B54708" />
      </linearGradient>
      <clipPath id="clip0_14577_90046">
        <rect fill="white" height="16" transform="matrix(-1 0 0 1 16 0)" width="16" />
      </clipPath>
    </defs>
  </svg>
);

export default LiquidityIcon;
